import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { resetForm } from 'State/forms/actions';
import { Filter, Main } from 'Containers';
import { NotificationDialog } from 'Components';
import { errorToast } from 'Common/ToastHelper';
import { OPEN_ORDERS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { OpenOrderReportEnum } from 'Common/FieldEnum';
import { GroupByOptionsEnum } from 'Common/Constants/Enumeration/OpenOrderReportEnum';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';

import OpenOrdersReportComponent from '../../openordersreport/components/OpenOrdersReport';
import {
  printReportData,
  clearPrintReportError,
} from './../../commonState/actions';
import * as CommonPrintSelector from '../../commonState/selectors';

import 'Styles/pages/reports/inventory/openordersreport.less';

const currentDate = moment();

class OpenOrdersReportContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    printLoading: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    fromDT: PropTypes.string,
    endDT: PropTypes.string,
    groupByOptionsValue: PropTypes.number,
    printError: PropTypes.object,
    printData: PropTypes.string,
  };

  static defaultProps = {
    fromDT: '',
    endDT: '',
    groupByOptionsValue: 0,
    printError: null,
    printData: '',
  };
  reactTableRef = React.createRef();
  state = {
    fromDateMin: null,
    fromDateMax: currentDate,
    toDateMin: moment().subtract(1, 'month'),
    toDateMax: currentDate,
    showPrintMsg: false,
    selectedGroupOption: GroupByOptionsEnum.SITE,
    selectedSites: [],
    allSites: [],
    activeIndexForFilter: 0,
  };

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.printReport,
            disabled: printLoading,
            loading: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  printReport = () => {
    const { fromDT, endDT } = this.props;
    const { selectedSites, allSites, selectedGroupOption } = this.state;
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: allSites };
    let sites = [];
    _.forEach(dataObjs.sortedData, obj => {
      if (obj._subRows) {
        const subRowSites = _.filter(
          obj._subRows,
          subObj => selectedSites.indexOf(subObj.Id) !== -1
        ).map(v => v.Id);
        sites = [...sites, ...subRowSites];
      } else {
        const id = obj.Id ? obj.Id : obj._original.Id;
        if (selectedSites.indexOf(id) !== -1) {
          sites.push(id);
        }
      }
    });
    if (sites.length) {
      const printObject = {
        FromDT: moment(fromDT).format(DATE_FORMAT_FOR_SERVER),
        ToDT: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        SiteIds: sites,
        GroupBy: selectedGroupOption,
        IsAllSitesSelected: allSites.length === sites.length,
      };
      this.props.printReportData('Order/GetOpenOrderPrint', printObject);
    } else {
      this.setState({
        showPrintMsg: true,
      });
    }
  };

  setSelectedSites = selectedSites => {
    this.setState({ selectedSites: selectedSites });
  };

  componentDidUpdate(prevProps) {
    const { clearPrintReportError, printData } = this.props;
    if (errorToast(this.props, prevProps, 'printError')) {
      this.props.clearPrintReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Open Order Report');
      clearPrintReportError();
    }
  }

  onChangeOfFromDT = (e, fromDate) => {
    this.selectFromDate(e, fromDate);
  };

  onChangeOfToDT = (e, endDate) => {
    this.selectToDate(e, endDate);
  };

  selectFromDate = (e, fromDate) => {
    this.setState({
      toDateMin: moment(fromDate, DATE_FORMAT_FOR_UI),
    });
  };

  selectToDate = (e, endDate) => {
    this.setState({
      fromDateMax: moment(endDate, DATE_FORMAT_FOR_UI),
    });
  };

  handlePrintMsgDialog = () => {
    this.setState({
      showPrintMsg: false,
    });
  };

  setGroupByOption = value => {
    this.setState({
      selectedGroupOption: value,
    });
  };

  clearFilters = () => {
    this.setState({
      selectedGroupOption: GroupByOptionsEnum.SITE,
    });
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(OPEN_ORDERS_REPORT_FORM_NAME);
  };

  getSitesCallback = allSites => {
    this.setState({ allSites });
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  render() {
    const { groupByOptionsValue } = this.props;
    return (
      <Fragment>
        <Filter title={'Reports | Open Orders'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <OpenOrdersReportComponent
            onChangeOfFromDT={this.onChangeOfFromDT}
            fromDateMax={this.state.fromDateMax}
            fromDateMin={this.state.fromDateMin}
            onChangeOfToDT={this.onChangeOfToDT}
            toDateMin={this.state.toDateMin}
            setGroupByOption={this.setGroupByOption}
            groupByOptionsValue={groupByOptionsValue}
            clearFilters={this.clearFilters}
            setSelectedSites={this.setSelectedSites}
            getSitesCallback={this.getSitesCallback}
            activeIndexForFilter={this.state.activeIndexForFilter}
            handleClick={this.handleClick}
            reactTableRef={this.reactTableRef}
          />
          <NotificationDialog
            title={'Open Orders Report'}
            showDialog={this.state.showPrintMsg}
            message={'You must select at least 1 site.'}
            onOkClick={this.handlePrintMsgDialog}
          />
        </Main>
      </Fragment>
    );
  }
}
const selector = formValueSelector(OPEN_ORDERS_REPORT_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(OPEN_ORDERS_REPORT_FORM_NAME)(state));

  return {
    initialValues: {
      [OpenOrderReportEnum.FromDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [OpenOrderReportEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [OpenOrderReportEnum.GroupByOptions]: GroupByOptionsEnum.SITE,
    },
    fromDT: selector(state, OpenOrderReportEnum.FromDT),
    endDT: selector(state, OpenOrderReportEnum.EndDT),
    groupByOptionsValue: selector(state, OpenOrderReportEnum.GroupByOptions),
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
  };
};

const mapDispatchToProps = {
  resetForm,
  printReportData,
  clearPrintReportError,
};

OpenOrdersReportContainer = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: OPEN_ORDERS_REPORT_FORM_NAME,
})(OpenOrdersReportContainer);

export const OpenOrdersReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(OpenOrdersReportContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/openordersreport/containers/OpenOrdersReport.js